export default __webpack_public_path__ + "9b8c95ac73dfe5b82564ea41b013bfe0.jpg";